'use client';

import { Formik, Form as FormikForm, FormikConfig } from 'formik';
import { ReactNode } from 'react';

import { FormFields, FormFieldsHalf } from './fields';
import { FieldInput, FieldCheckbox, FieldPhoneInput, FieldMaskedInput } from './fields/tools';

type FormProps<T> = FormikConfig<T> & {
  children: ReactNode;
};

const FormComponent = <T extends object>({
  initialValues,
  validationSchema,
  validate,
  onSubmit,
  children,
  ...restProps
}: FormProps<T>) => {
  return (
    <Formik<T>
      initialValues={initialValues}
      validate={validate}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      enableReinitialize
      {...restProps}
    >
      <FormikForm>{children}</FormikForm>
    </Formik>
  );
};

const Fields = Object.assign(FormFields, {
  Half: FormFieldsHalf,
});

export const Form = Object.assign(FormComponent, {
  Fields,
  Input: FieldInput,
  Checkbox: FieldCheckbox,
  PhoneInput: FieldPhoneInput,
  MaskedInput: FieldMaskedInput,
});
